{
    "webshop_offer_voucher_correctCode": "Juiste code ingevuld",
    "webShop_howToFindId_desc": "Je persoonlijke ID vind je en kun je kopiëren in je spelersprofiel.",
    "webShop_howToFindId_link": "Waar vind ik mijn persoonlijke ID?",
    "webshop_offer_voucher_codeIsIncorrect": "Code is onjuist",
    "webshop_offer_voucher_enterYourCode": "Voer je persoonlijke ID in",
    "webShop_unexpectedError_desc": "Er is een onverwachte fout opgetreden. Probeer het later opnieuw.",
    "webShop_accountBanned_desc": "Account verbannen!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Algemene voorwaarden",
    "webshop_purchase_privacyPolicy": "Privacybeleid",
    "webshop_legal_1": "Juridisch",
    "webshop_support_1": "Ondersteuning",
    "mbs_access_welcome_desc": "Welkom, {0}",
    "btn_login": "Aanmelden",
    "mbs_access_error_sessionExpired_desc": "Je sessie is verlopen. Voer je account-ID handmatig in."
}
